<template>
  <div class="box">
    <div class="head">
      <p class="title">{{ title }}</p>
      <p class="right"><slot name="head-right"></slot></p>
    </div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "box-section",
    props: {
      title: String,
    }
  }
</script>

<style lang="less" scoped>
.box {
  background-color: #fff;

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;

    .title {
      font-weight: bold;
      border-left: 3px solid #bea473;
      padding-left: 8px;
      font-size: 14px;
      line-height: 14px;
    }

    .right {
      color: #676767;
      font-size: 12px;
    }
  }
}
</style>